import React from "react";
import GroupsInspector from "@Components/groups/GroupsInspector";
import PageHelmet from "@Components/shared/PageHelmet";

const GroupsPage: React.FC = () => {
    return (
        <div>
            <PageHelmet name={"Groups"} />
            <div id="content">
                <div className="floating-content floating-content-right">
                    <div className="floating-content-right-inner">
                        <GroupsInspector key={"groups-inspector"} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GroupsPage;
